import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/junli/work/fun/hooks/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { useToggle } from "../../index";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "usetoggle"
    }}>{`useToggle`}</h1>
    <p>{`状态切换`}</p>
    <hr />
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`type IState = string | number | boolean | undefined;

const [
  offValue: IState = false,
  onValue: IState = true,
] = useImage(
  state: IState, // 当前状态
  toggle: (nextValue?: any) => void // 切换
);
`}</code></pre>
    <hr />
    <h2 {...{
      "id": "demo"
    }}>{`DEMO`}</h2>
    <Playground __position={2} __code={'() => {\n  const [state1, toggle1] = useToggle()\n  const [state2, toggle2] = useToggle(\'off\', \'on\')\n  return (\n    <ul>\n      <li>\n        <div>\n          <h4>默认</h4>\n          <div>状态: {`${state1}`}</div>\n          <div>\n            <button onClick={toggle1}>toggle</button>\n            <button onClick={() => toggle1(true)}>set true</button>\n            <button onClick={() => toggle1(false)}>set false</button>\n          </div>\n        </div>\n      </li>\n      <li>\n        <h4>on/off</h4>\n        <div>状态: {`${state2}`}</div>\n        <div>\n          <button onClick={toggle2}>toggle</button>\n          <button onClick={() => toggle2(\'on\')}>set on</button>\n          <button onClick={() => toggle2(\'off\')}>set off</button>\n        </div>\n      </li>\n    </ul>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      useToggle,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const [state1, toggle1] = useToggle();
        const [state2, toggle2] = useToggle('off', 'on');
        return <ul>
        <li>
          <div>
            <h4>默认</h4>
            <div>状态: {`${state1}`}</div>
            <div>
              <button onClick={toggle1}>toggle</button>
              <button onClick={() => toggle1(true)}>set true</button>
              <button onClick={() => toggle1(false)}>set false</button>
            </div>
          </div>
        </li>
        <li>
          <h4>on/off</h4>
          <div>状态: {`${state2}`}</div>
          <div>
            <button onClick={toggle2}>toggle</button>
            <button onClick={() => toggle2('on')}>set on</button>
            <button onClick={() => toggle2('off')}>set off</button>
          </div>
        </li>
      </ul>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      